import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import './i18n/config'
import App from './App.tsx'
import './index.css'

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 5 * 60 * 1000, // 5 minutes
      refetchOnWindowFocus: false,
    },
  },
})

// Monaco editor can reject with "Canceled" when models are disposed (e.g. on value update); suppress uncaught promise
window.addEventListener('unhandledrejection', (event) => {
  const msg = event.reason?.message ?? String(event.reason)
  if (msg === 'Canceled' || (event.reason?.name === 'Canceled')) {
    event.preventDefault()
    event.stopPropagation()
  }
})

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </QueryClientProvider>
  </React.StrictMode>,
)
